module.exports = __webpack_public_path__ + "img/arrow_drop_down.fc77a114.svg";